import { GetStaticPaths, GetStaticProps } from 'next';
import { DefaultSeoProps } from 'next-seo';
import { memo, useMemo } from 'react';

import AggregateLayout from '~/components/discussions/AggregateLayout';

import {
  DEAL_COMMENT_TYPE,
  DISCUSSION,
  REVIEW_SORT_OPTIONS,
} from '~/lib/discussions/constants';
import { getQAndRPageCanonicalUrl } from '~/lib/discussions/utils';
import { getDealStaticPaths, withDealStaticProps } from '~/lib/product/fetch';
import { Deal } from '~/types/deal';

export const getStaticProps: GetStaticProps = withDealStaticProps;
export const getStaticPaths: GetStaticPaths = getDealStaticPaths;

function ReviewAggregatePage({ deal }: { deal: Deal }) {
  const seoOptions: DefaultSeoProps = useMemo(
    () => ({
      title: `${
        deal.public_name
      } Reviews ${new Date().getFullYear()}: Verified Ratings, Pros & Cons`,
      description: `${deal.public_name} is rated ${deal.deal_review.average_rating} out of 5 based on reviews from ${deal.deal_review.review_count} verified users. Explore helpful comments, compare pros and cons, and find out how ${deal.public_name} works for a business like yours.`,
      canonical: getQAndRPageCanonicalUrl(deal.slug, DISCUSSION.REVIEWS),
    }),
    [
      deal.deal_review.average_rating,
      deal.deal_review.review_count,
      deal.public_name,
      deal.slug,
    ],
  );

  return (
    <>
      <AggregateLayout
        deal={deal}
        seoOptions={seoOptions}
        title="Reviews"
        discussionType={DISCUSSION.REVIEWS}
        commentType={DEAL_COMMENT_TYPE.REVIEW}
        sortOptions={REVIEW_SORT_OPTIONS}
      />
    </>
  );
}

export default memo(ReviewAggregatePage);
